export const TopBar = ({ children }: { children: React.ReactNode }) => {
  return (
    <header className="fixed top-0 left-safe right-safe z-50 w-full border-b bg-white shadow">
      <div className="mx-auto container flex h-14 max-w-screen-xl items-center lg:h-16 pl-safe pr-safe">
        <div className="flex flex-1 items-center justify-between">
          {children}
        </div>
      </div>
    </header>
  );
};
